/**
 * @file     BreakdownList.tsx
 * @purpose  "What the number includes": a hairline list of figure rows, each
 *           with a label, a value and a one-line note on where it comes from.
 */
import Box from '@mui/material/Box';
import { hairline, hubColors } from '@/components/hub/hubKitStyles';

export type BreakdownRow = { label: string; value: string; note?: string };

export function BreakdownList({ rows, label }: { rows: BreakdownRow[]; label: string }) {
  return (
    <Box component="dl" aria-label={label} sx={{ m: 0, borderTop: hairline }}>
      {rows.map((row) => (
        <Box
          key={row.label}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) auto',
            columnGap: 2,
            rowGap: 0.25,
            py: 2,
            borderBottom: hairline,
          }}
        >
          <Box component="dt" sx={{ fontSize: 15.5, fontWeight: 500, color: hubColors.textPrimary }}>{row.label}</Box>
          <Box component="dd" sx={{ m: 0, fontSize: 15.5, fontWeight: 500, fontVariantNumeric: 'tabular-nums', textAlign: 'end' }}>
            {row.value}
          </Box>
          {row.note ? (
            <Box component="dd" sx={{ m: 0, gridColumn: '1 / -1', fontSize: 13.5, lineHeight: 1.5, color: hubColors.textSecondary }}>
              {row.note}
            </Box>
          ) : null}
        </Box>
      ))}
    </Box>
  );
}
